/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Einvoice_Viewer_StatusInputs */

const vi_einvoice_viewer_status = /** @type {(inputs: Einvoice_Viewer_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trạng thái: ${i?.status}`)
};

/**

* @param {Einvoice_Viewer_StatusInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_viewer_status = /** @type {((inputs: Einvoice_Viewer_StatusInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Viewer_StatusInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_viewer_status(inputs)
});